/* Vivapaw site tracking (2026-10-20). Oliver: "kiek iš kokio adso ir kaip save veda klientai, kiek sekundžių kokiam page,
   kiek % prasvaipino, ką paspaudė ir kur išėjo".
   Anonymous: random visitor id (localStorage vp_vid), session id (new after 30 min idle or a new ad click), page-view id.
   Never sends names, e-mails, typed text or IPs. Rows go to Supabase public.vp_events (the key may only INSERT):
     view      page opened (+ previous page of this session and seconds since it, visit number)
     leave     summary each time the page is hidden or closed (max 6 per view): seconds, visible seconds, max scroll %,
               deepest section / heading, seconds per section, last 40 clicks (text + link), link clicked just before leaving
     atc       add to cart succeeded (variant, quantity, Abo or not, value)
     checkout  checkout button pressed
   Exit page = the last view of a session (SQL, schema vp). Checkout steps + purchase come from the Shopify custom pixel
   (tracking/pixel/vp-checkout-pixel.js), which reads the same vp_vid / vp_s. After an add to cart the cart gets
   attributes _vp_vid / _vp_sid / _vp_src / _vp_ad, so every order in admin shows its ad.
   Flags: ?vp_me=1 marks this browser as Oliver's (flag 'me', ?vp_me=0 removes), ?vp_qa=1 or utm_source=claude-qa = test ('qa'). */
(function () {
  'use strict';
  var C = window.VP_TRACK || {};
  if (!C.u || !C.k || window.__vpTrack) return;
  try { if (window.top !== window.self) return; } catch (e) { return; }
  window.__vpTrack = 1;
  var F = window.fetch ? window.fetch.bind(window) : null;
  if (!F) return;

  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} }
  function json(s) { try { return JSON.parse(s || 'null'); } catch (e) { return null; } }
  function rid() { try { return crypto.randomUUID().replace(/-/g, ''); } catch (e) { return (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 32); } }
  function cut(s, n) { s = String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n) : s; }
  function send(row) {
    try {
      F(C.u.replace(/\/$/, '') + '/rest/v1/vp_events', {
        method: 'POST', keepalive: true,
        headers: { apikey: C.k, Authorization: 'Bearer ' + C.k, 'Content-Type': 'application/json', Prefer: 'return=minimal' },
        body: JSON.stringify(row)
      }).catch(function () {});
    } catch (e) {}
  }

  /* who and from where */
  var q = new URLSearchParams(location.search), now = Date.now(), ua = navigator.userAgent || '';
  if (q.get('vp_me') === '1') set('vp_me', '1');
  if (q.get('vp_me') === '0') set('vp_me', null);
  if (q.get('vp_qa') === '1' || q.get('utm_source') === 'claude-qa') set('vp_qa', '1');
  var flag = navigator.webdriver || /bot|crawl|spider|headless|facebookexternalhit|meta-externalagent|lighthouse/i.test(ua) ? 'bot'
    : get('vp_qa') ? 'qa' : get('vp_me') ? 'me' : null;

  var vid = get('vp_vid');
  if (!vid || vid.length < 8) { vid = rid(); set('vp_vid', vid); }
  var utm = {};
  ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (k) { var v = q.get('utm_' + k); if (v) utm[k] = cut(v, 150); });
  var adId = cut(q.get('ad_id') || q.get('utm_id') || '', 40) || null;
  var refHost = '';
  try { if (document.referrer) refHost = new URL(document.referrer).host; } catch (e) {}
  var internalRef = !refHost || refHost === location.host || /(^|\.)(shopify\.com|myshopify\.com|shop\.app|paypal\.com|klarna\.com|stripe\.com)$/i.test(refHost);

  var s = json(get('vp_s')) || {};
  var newAd = utm.source && JSON.stringify(utm) !== JSON.stringify(s.utm || {});
  if (!s.id || now - (s.t || 0) > 30 * 60 * 1000 || newAd || (!internalRef && !utm.source && now - (s.t || 0) > 5 * 60 * 1000)) {
    var vn = (parseInt(get('vp_vn') || '0', 10) || 0) + 1; set('vp_vn', String(vn));
    s = {
      id: rid(), t: now, vn: vn, ad: adId, fb: q.get('fbclid') ? 1 : 0, land: location.pathname,
      utm: utm.source ? utm : (!internalRef ? { source: cut(refHost.replace(/^www\./, ''), 150), medium: 'referral' } : { source: 'direct' })
    };
  }
  if (adId) s.ad = adId;
  if (utm.source && !get('vp_ft')) set('vp_ft', JSON.stringify({ utm: utm, ad: adId, t: now }));
  /* gap = seconds between leaving the previous page and opening this one */
  var prev = s.prev || null, gap = s.lt ? Math.round((now - s.lt) / 1000) : null;
  s.prev = cut(location.pathname, 200); s.lt = 0; s.t = now;
  set('vp_s', JSON.stringify(s));

  var w = window.innerWidth || 0, device = w < 768 ? 'mobile' : (w < 1100 ? 'tablet' : 'desktop');
  var app = /Instagram/i.test(ua) ? 'ig' : /FBAN|FBAV|FB_IAB/i.test(ua) ? 'fb' : null;
  var pv = rid(), t0 = Date.now();
  var u = s.utm || {};
  var base = {
    vid: vid, sid: s.id, page_type: cut(C.pt || 'other', 30), path: cut(location.pathname, 200), a: cut(q.get('a') || '', 30) || null,
    utm_source: u.source || null, utm_medium: u.medium || null, utm_campaign: u.campaign || null, utm_content: u.content || null,
    utm_term: u.term || null, ad_id: s.ad || null, referrer: refHost && !internalRef ? cut(refHost, 200) : null, device: device,
    country: cut((window.Shopify && window.Shopify.country) || '', 5) || null, flag: flag
  };
  function row(event, data) { var o = { pv: pv, event: event, data: data || {} }; for (var k in base) o[k] = base[k]; return o; }
  function touch() { var x = json(get('vp_s')); if (x && x.id === s.id) { x.t = Date.now(); x.lt = Date.now(); set('vp_s', JSON.stringify(x)); } }

  /* page parts: theme sections; on article pages with few sections, the h2 headings */
  var marks = [];
  function mapMarks() {
    var root = document.querySelector('main') || document.getElementById('MainContent') || document.body;
    var secs = [].slice.call(root.querySelectorAll('.shopify-section')).filter(function (el) { return el.offsetHeight > 40; }).map(function (el) {
      var id = el.id || '', n = id.indexOf('__') > -1 ? id.split('__').pop() : id.replace('shopify-section-', '');
      return { el: el, n: cut(n.replace(/_[A-Za-z0-9]{6}$/, ''), 30) || 'section' };
    });
    /* article pages (advertorials): headings show where reading stopped; other pages: theme sections */
    var hs = C.pt === 'page' ? [].slice.call(root.querySelectorAll('h2')).filter(function (el) { return el.offsetHeight > 0; }) : [];
    if (hs.length >= 2) secs = hs.map(function (el, i) { return { el: el, n: cut((i + 1) + ' ' + el.textContent, 30), h: 1 }; });
    marks = secs;
  }
  var visT = 0, visFrom = document.visibilityState === 'visible' ? Date.now() : 0, maxY = 0, maxH = 0, deepI = -1, deepN = null, tsec = {}, clicks = [],
      atc = 0, nextHref = null, nextAt = 0, sent = 0, lastClick = 0, lastLeave = 0;
  function visNow() { return visT + (visFrom ? Date.now() - visFrom : 0); }
  /* on desktop the theme scrolls inside div.page-wrapper (html/body overflow hidden), on phones the window scrolls */
  var SE = null;
  function findScroller() {
    var de = document.scrollingElement || document.documentElement;
    if (de.scrollHeight > window.innerHeight + 20) return null;
    var best = null, bh = 0;
    [].slice.call(document.querySelectorAll('.page-wrapper, main, #MainContent, body > div')).forEach(function (el) {
      if (/(auto|scroll)/.test(getComputedStyle(el).overflowY) && el.scrollHeight > el.clientHeight + 20 && el.scrollHeight > bh) { best = el; bh = el.scrollHeight; }
    });
    return best;
  }
  function sTop() { return SE ? SE.scrollTop : (window.pageYOffset || 0); }
  function sView() { return SE ? SE.clientHeight : window.innerHeight; }
  function sOff() { return SE ? SE.getBoundingClientRect().top : 0; }
  function pageH() { return SE ? SE.scrollHeight : (Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) || 1); }
  /* scroll % and deepest part are measured while scrolling (an open cart drawer makes the page look 1 screen tall) */
  function scrollPct() { return Math.min(100, Math.round(100 * maxY / (maxH || pageH()))); }
  function onScroll() {
    var y = sTop() + sView(), h = pageH(); if (y > maxY) maxY = y; if (h > maxH) maxH = h;
    var di = deepIdx(); if (di > deepI) { deepI = di; deepN = marks[di].n; }
  }
  /* deepest part reached = last mark whose top was ever above 60 % of the screen */
  function deepIdx() {
    var lim = maxY - sView() * 0.4, top = sTop() - sOff(), d = -1;
    for (var i = 0; i < marks.length; i++) { if (marks[i].el.getBoundingClientRect().top + top < lim) d = i; }
    return d;
  }
  function curMark() {
    var mid = window.innerHeight / 2, cur = null;
    for (var i = 0; i < marks.length; i++) {
      var r = marks[i].el.getBoundingClientRect();
      if (marks[i].h) { if (r.top <= mid) cur = marks[i].n; else break; }
      else if (r.top <= mid && r.bottom >= mid) return marks[i].n;
    }
    return cur;
  }
  var raf = 0;
  document.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; onScroll(); }); }, { passive: true, capture: true });
  setInterval(function () { if (document.visibilityState !== 'visible') return; var m = curMark(); if (m) tsec[m] = (tsec[m] || 0) + 1; }, 1000);

  /* clicks: what was pressed and where it leads, never what was typed */
  document.addEventListener('click', function (e) {
    try {
      var el = e.target && e.target.closest && e.target.closest('a,button,label,summary,input,select,[role=button],img');
      if (!el || e.timeStamp - lastClick < 80) return;
      lastClick = e.timeStamp;
      var tag = el.tagName, k, to = null;
      if (tag === 'INPUT' && el.type === 'checkbox') k = (el.name || 'check') + ' ' + (el.checked ? 'on' : 'off');
      else if (tag === 'INPUT' && el.type === 'radio') k = 'pick ' + (el.value || '');
      else if (tag === 'INPUT' || tag === 'SELECT') k = 'field ' + (el.name || el.type || tag.toLowerCase());
      else if (tag === 'SUMMARY') k = 'open ' + el.textContent;
      else if (tag === 'IMG') k = 'image ' + (el.alt || '');
      else k = el.getAttribute('aria-label') || el.textContent || el.value || tag.toLowerCase();
      if (tag === 'A' && el.href) {
        try { var lu = new URL(el.href, location.href); to = cut(lu.host === location.host ? lu.pathname + (lu.hash || '') : lu.host, 120); nextHref = to; nextAt = Date.now(); } catch (x) {}
      }
      var c = [Math.round((Date.now() - t0) / 1000), cut(String(k).replace(/[→›»]+/g, ''), 50)];
      if (to) c.push(to);
      clicks.push(c); if (clicks.length > 40) clicks.shift();
      var isCo = el.matches('[name=checkout], a[href*="/checkout"], [href*="/checkouts/"]') || (el.form && /checkout/.test(el.form.getAttribute('action') || '') && tag === 'BUTTON');
      if (isCo) send(row('checkout', { at: c[0], btn: c[1] }));
      /* leaving to another page: send the summary now, the unload moment is less reliable */
      var navAway = isCo || (to && tag === 'A' && el.target !== '_blank' && !e.metaKey && !e.ctrlKey && !e.shiftKey && !/^#/.test(el.getAttribute('href') || '') && to.split('#')[0] !== location.pathname);
      if (navAway) leave('nav');
    } catch (x) {}
  }, true);

  /* add to cart: watch the theme's own /cart/add requests; then tag the cart once per session */
  var tagTimer = 0;
  function tagCart() {
    clearTimeout(tagTimer);
    tagTimer = setTimeout(function () {
      F('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var at = (cart && cart.attributes) || {};
        if (at._vp_sid === s.id) return;
        var src = [u.source, u.campaign, u.content].filter(Boolean).join(' / ');
        return F('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _vp_vid: vid, _vp_sid: s.id, _vp_src: cut(src, 150) || 'direct', _vp_ad: s.ad || '', _vp_land: cut(s.land || '', 120) } })
        });
      }).catch(function () {});
    }, 1500);
  }
  function onAdd(res) {
    atc++;
    var items = res && (res.items || (res.id ? [res] : [])) || [];
    var list = items.slice(0, 6).map(function (i) { return { v: i.variant_id || i.id, q: i.quantity, p: i.final_line_price != null ? i.final_line_price / 100 : null, abo: i.selling_plan_allocation ? 1 : 0, t: cut(i.product_title || i.title || '', 50) }; });
    var value = list.reduce(function (a, i) { return a + (i.p || 0); }, 0);
    send(row('atc', { at: Math.round((Date.now() - t0) / 1000), items: list, value: Math.round(value * 100) / 100 }));
    tagCart();
  }
  window.fetch = function (input, init) {
    var p = F.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && /post/i.test(method)) {
        p.then(function (r) { if (r && r.ok) r.clone().json().then(onAdd, function () { onAdd(null); }); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  /* summaries when the page is hidden or closed */
  function summary(why) {
    var top = Object.keys(tsec).sort(function (a, b) { return tsec[b] - tsec[a]; }).slice(0, 10), ts = {};
    top.forEach(function (k) { ts[k] = tsec[k]; });
    var d = {
      why: why, n: sent + 1, secs: Math.round((Date.now() - t0) / 1000), vis: Math.round(visNow() / 1000), sc: scrollPct(),
      deep: deepN, deep_i: deepI + 1, marks: marks.length, at: curMark(), tsec: ts,
      clicks: clicks.slice(-40), atc: atc
    };
    if (nextHref && Date.now() - nextAt < 4000) d.next = nextHref;
    return d;
  }
  function leave(why) {
    if (sent >= 6) return;
    if ((why === 'hide' || why === 'close') && Date.now() - lastLeave < 1500) return;
    lastLeave = Date.now();
    send(row('leave', summary(why))); sent++;
    touch();
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { if (visFrom) { visT += Date.now() - visFrom; visFrom = 0; } leave('hide'); }
    else { visFrom = Date.now(); }
  });
  window.addEventListener('pagehide', function () { if (visFrom) { visT += Date.now() - visFrom; visFrom = 0; } leave('close'); });

  function view(extra) {
    SE = findScroller(); mapMarks(); onScroll();
    var d = { prev: prev, gap: gap, vn: s.vn, vw: w, vh: window.innerHeight || 0, marks: marks.length, title: cut(document.title, 80) };
    if (C.h) d.handle = cut(C.h, 80);
    if (app) d.app = app;
    if (s.fb) d.fb = 1;
    var ft = json(get('vp_ft'));
    if (ft && ft.utm && ft.utm.content && ft.utm.content !== u.content) d.ft = cut(ft.utm.content, 60);
    if (extra) for (var k in extra) d[k] = extra[k];
    send(row('view', d));
  }
  /* back/forward from the bfcache = a new view of this page */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var x = json(get('vp_s')) || s; prev = x.prev || null; gap = x.lt ? Math.round((Date.now() - x.lt) / 1000) : null;
    x.prev = cut(location.pathname, 200); x.lt = 0; x.t = Date.now(); set('vp_s', JSON.stringify(x));
    pv = rid(); t0 = Date.now(); visT = 0; visFrom = Date.now(); maxY = 0; maxH = 0; deepI = -1; deepN = null; tsec = {}; clicks = []; atc = 0; sent = 0; nextHref = null;
    view({ back: 1 });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { view(); }); else view();
  window.addEventListener('load', function () { SE = findScroller(); mapMarks(); onScroll(); });
})();
